<template>
    <div class="badge-detail-page" :class="{'reward': useData?.state == 1}" @click="null">
        <!-- 背景图 -->
        <div class="badge-detail-page-bg"></div>
        <!-- top -->
        <div class="top" :style="{paddingTop: 10 + statusBarHeight + 'px'}">
            <Back 
                :clickHandle="handleClosePage"
                :innerText="localesPackage?.['badgewall_back']?.[localesEnv]"
            />
            <div class="top-title">
                {{ localesPackage?.['badgewall_achievement_detail']?.[localesEnv] }}
            </div>
        </div>
        <!-- 徽章-图片 -->
        <div class="badge-iconView">
            <!-- yuli-图文 -->
            <div class="yuli-view" v-if="useData?.isYuli?.id">
                <img
                    class="yuli-view-img"
                    :src="useData?.badgeIcon || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png')"
                />
                <span class="yuli-view-id"
                      :class="{
                        'yuli-view-id-gold': useData?.isYuli?.role_type == 6
                      }">
                    #{{ useData?.isYuli?.id }}
                </span>
            </div>
            <!-- 普通徽章-处理 -->
            <div v-else>
                <img
                    class="badge-iconView-badgeImg"
                    :src="useData?.badgeIcon"
                />
            </div>
            <!-- 背底-彩虹 -->
            <div class="badge-iconView-rainbow"></div>
            <!-- 徽章阴影 -->
            <div class="badge-iconView-shadow"></div>
        </div>
        <!-- 领取列表展示 -->
        <div class="reward-list">
            <div class="reward-list-item" 
                 v-for="(item, index) in useChildrenGroup" 
                 :class="{
                    'active': item?.completed_count >= item?.max_progress,
                    'hadClaim': item?.is_claimed
                 }"
                 :key="index">
                <div class="reward-list-item-left">
                    <div class="reward-list-item-left-label">{{ item?.name }}</div>
                    <div class="reward-list-item-left-abstract">{{ item?.abstract }}</div>
                    <div class="reward-list-item-left-process">
                        <Process 
                            :cur_kep="item?.completed_count || 0"
                            :total_kep="item?.max_progress || 1"
                            :isFull="(item?.completed_count >= item?.max_progress) || item?.is_claimed"
                        />
                    </div>
                </div>
                <div class="reward-list-item-right">
                    <div class="reward-list-item-right-proplist">
                        <div class="reward-list-item-right-proplist-box" v-for="(rewardItem, rewardIndex) in item?.rewardGroup" :key="rewardIndex">
                            <PropItem 
                                :propStyle="{
                                    'scale': 0.72
                                }"
                                :prop_img="rewardItem?.url"
                                :prop_number="NumberFormatHanle(rewardItem?.number)"
                                :prop_type="rewardItem?.type"
                            />
                            <!-- light effect -->
                            <div class="reward-list-item-right-proplist-light-view-Abs" v-show="(item?.completed_count >= item?.max_progress) && !item?.is_claimed">
                                <div class="reward-list-item-right-proplist-light-view-Rel">
                                    <!-- 光效-星星 -->
                                    <div class="reward-list-item-right-proplist-light">
                                        <div class="hideBoxTop">
                                            <img class="reward-list-item-right-proplist-light-top" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                                        </div>
                                        <div class="hideBoxBottom">
                                            <img class="reward-list-item-right-proplist-light-bottom" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                                        </div>
                                        <div class="hideBoxLeft">
                                            <img class="reward-list-item-right-proplist-light-left" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                                        </div>
                                        <div class="hideBoxRight">
                                            <img class="reward-list-item-right-proplist-light-right" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                                        </div>
                                    </div>
                                    <!-- 光效呼吸 -->
                                    <div class="reward-list-item-right-proplist-light-view-breathe"></div>
                                </div>
                            </div>
                            <!-- 已领取 -->
                            <div class="reward-list-item-right-proplist-hadClaim" v-show="item?.is_claimed">
                                <img :src="require('@/assets/images/YuliApp/badgeWall/btn_task_yes.png')"/>
                            </div>
                        </div>
                    </div>
                    <div class="reward-list-item-right-button"
                         :class="{
                            'btn_active': (item?.completed_count >= item?.max_progress) && !item?.is_claimed,
                         }"
                         :style="{
                            paddingRight: (localesEnv == 'ja' && item?.is_claimed) ? 'unset' : ''
                         }"
                         @click="ClaimHandle(item)">
                         <img :src="require('@/assets/images/YuliApp/badgeWall/dagou_white.png')" v-if="item?.is_claimed">
                        {{ 
                            item?.completed_count >= item?.max_progress 
                            ? (
                                item?.is_claimed 
                                ? localesPackage?.['badgewall_claimed']?.[localesEnv]
                                : localesPackage?.['badgewall_claim']?.[localesEnv]
                            ) : (localesPackage?.['badgewall_incomplete']?.[localesEnv])
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, getCurrentInstance, ref, computed, nextTick } from "vue";
import _ from "lodash";
import audioManager from "@/utils/audioManager";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import Process from "../Process";
import PropItem from "../PropItem";
import { getTime, NumberFormat } from "@/utils/utils";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import Back from "@/components/universal/Back";

export default {
components: {
    Process,
    PropItem,
    Back
},
props: {
    data: {
        type: Object,
        default: () => {
            return null;
        },
    },
    userInfo: {
        type: Object,
        default: () => {
            return null;
        },
    }
},
watch: {
    data: {
        async handler(value) {
            console.log('data: ',value);
            if(value?.label){
                this.useData = value;
                this.childrenGroupInit(value?.children);
            }
        },
        immediate: true,
        deep: true,
    },
    userInfo: {
        async handler(value) {
            console.log('userInfoData: ',value);
            if(value){
                this.userInfoData = value;
            }
        },
        immediate: true,
        deep: true,
    },
    languageEnv: {
        async handler(value) {
            if(value){
            this.localesEnv = value;
            }
        },
        immediate: true,
        deep: true,
    },
    languagePackage: {
        async handler(value) {
            if(value){
            this.localesPackage = value;
            }
        },
        immediate: true,
        deep: true,
    },
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
    }),
},
setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const { cur_kep, total_kep } = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const useData = ref(null);
    const useChildrenGroup = ref([]);
    const userInfoData = ref(null);
    const getTimeHanlde = getTime;
    const NumberFormatHanle = NumberFormat;
    /**关键字段表 */
    const keyMap = {
        /**奖励奖品类型 */
        reward_type: {
            /**arg */
            1: {
                text: 'ARG',
                status: 1,
                url: require('@/assets/images/YuliApp/badgeWall/coin/Arg.png'),
            },
            /**art */
            2: {
                text: 'ART',
                status: 2,
                url: require('@/assets/images/YuliApp/badgeWall/coin/Art.png'),
            },
            /**g-arg */
            3: {
                text: 'G-ARG',
                status: 3,
                url: require('@/assets/images/YuliApp/badgeWall/coin/G-Arg.png'),
            },
            /**道具 */
            4: {
                text: '道具',
                status: 4,
            },
            /**头像 */
            5: {
                text: '头像',
                status: 5,
            },
            /**星尘 */
            6: {
                text: 'Stardust',
                status: 6,
                url: require('@/assets/images/YuliApp/badgeWall/coin/stardust.svg'),
            },
        }
    }
    onBeforeMount(()=>{
        appBridging.getStatusBarHeight();
    })

    /**
     * 获取星图的class
     * @param {*} index 
     * @param {*} maxStar 
     */
    const getStarClass = (index, maxStar) => {
        return {
            'stars-view-center': maxStar == 1 || 
                    (maxStar == 2 ) ||
                    (maxStar == 3 && index == 2) || 
                    (maxStar == 4 ) || 
                    (maxStar == 5 && index == 3),
            [`stars-view-item-${index}`]: true
        }
    }

    const ClaimHandle = (itemInfo) => {
        if(itemInfo.is_claimed)return;
        if(itemInfo.completed_count < itemInfo.max_progress)return;
        if(!itemInfo.claimAble){
            proxy.$toast.show({
                msg: localesPackage.value?.['badgewall_claim_error_tips']?.[localesEnv.value],
                type: TOAST_TYPE.WARN,
            })
            return;
        }
        emit('handle', 'claim', {
            ...itemInfo,
            starId: itemInfo.id,
            reward: itemInfo.rewardGroup?.slice(1),
            isYuli: useData.value?.isYuli,
            yuliId: useData.value?.yuliId,
            badgeIcon: useData.value?.badgeIcon
        });
    }
    
    const handleClosePage = () => {
        emit('handle', false);
    }

    /** 奖品栏处理*/
    const rewardItemBoxHandle = (item) => {
        const group = [];
        // 塞入徽章
        group.push({
            url: item?.icon_url || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
            name: item?.name,
            number: null,
            type: 5,
        })
        // 塞入道具 - 含奖品类型判断
        let reward = {}
        const { reward_type, reward_value, prop_info, score } = item;
        if(reward_type <= 3 || reward_type == 6){
            reward = {
                url: keyMap.reward_type?.[reward_type]?.url,
                number: reward_value,
                type: 2,// 道具品质
                name: keyMap.reward_type?.[reward_type]?.text
            }
        }else if(reward_type == 4){
            reward = {
                url: prop_info?.img_url,
                number: reward_value,
                type: prop_info?.level,// 道具品质
                name: prop_info?.name
            }
        }else {
            reward = {
                url: prop_info?.img_url,
                number: null,
                type: 1,// 道具品质
                name: 'avatar_url'
            }
        }
        group.push(reward);
        // 塞入成就分
        group.push({
            url: require('@/assets/images/YuliApp/badgeWall/coin/achievement_points_icon.png'),
            name: 'Achievement Points',
            number: score,
            type: 4,
        })
        return group;
    }

    /** 徽章全部子节点处理函数*/
    const childrenGroupInit = (array = []) => {
        let isFirstClaimChild = true;
        const group = array
        ?.map(item => {
            const claimState = (item.completed_count >= item.max_progress) && !item.is_claimed;
            const res = {
                ...item,
                priority: item.is_claimed ? 0 : (item.completed_count >= item.max_progress) ? 2 : 1,
                rewardGroup: rewardItemBoxHandle(item),
                claimAble: isFirstClaimChild && claimState
            };
            if(claimState)isFirstClaimChild = false;
            return res;
        })
        ?.sort((pre,next) => next.priority - pre.priority) || [];
        useChildrenGroup.value = group;
        return group;
    }

    return {
        localesPackage,
        localesEnv,
        getStarClass,
        handleClosePage,
        ClaimHandle,
        childrenGroupInit,
        getTimeHanlde,
        NumberFormatHanle,
        useData,
        useChildrenGroup,
        userInfoData
    };
},
};
</script>
  
<style lang="less" scoped>
    @topHeight: 60px;
    @animTime: 2s;
    @lightSize: 52px;
    .badge-detail-page{
        width: 100vw;
        height: 100vh;
        position: fixed;
        background: linear-gradient(180deg,
            #A89E80 0%,
            #A39988 15%,
            #D0C6B6 50%,
            #B4AA99 82%,
            #AFA494 100%
        );
        z-index: 999;
        top: 0;
        left: 0;
        overflow-y: scroll;
        overflow-x: hidden;
        &-bg{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: -1;
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/MedelWallBg.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
        .top{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: @topHeight;
            &-title{
                position: absolute;
                bottom: 40%;
                right: 15px;
                transform: translateY(50%);
                color: #ffffff;
                text-align: right;
                font-family: "PingFang SC";
                font-size: 22px;
                font-weight: 600;

            }
        }
    }
    // 徽章
    .badge-iconView{
        margin-top: 60px;
        width: 100%;
        height: 220px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        &-rainbow{
            width: 362px;
            height: 226px;
            position: absolute;
            top: 52.5%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url("~@/assets/images/YuliApp/badgeWall/light_rainbow.png") no-repeat
            top left;
            background-size: 100% 100%;
            // opacity: 0.25;
            z-index: -1;
        }
        &-badgeImg{
            width: 160px;
            height: 160px;
        }
        &-shadow{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 35px;
            filter: blur(2px);
            width: 112px;
            height: 10px;
            background: rgba(139, 117, 90, 0.4);
            z-index: -1;
            border-radius: 50%;
        }
    }
    .reward-list{
        width: 347px;
        margin: 0 auto;
        margin-top: -25px;
        height: calc(100vh * 500/812);
        overflow-y: scroll;
        overflow-x: hidden;
        // 隐藏滚动条
        &::-webkit-scrollbar {
            display: none;
        }
        &-item{
            width: 347px;
            height: 98px;
            margin-bottom: 6px;
            box-sizing: border-box;
            background: url("~@/assets/images/YuliApp/badgeWall/reward-item-bg-off.png") no-repeat
            top left;
            background-size: 100% 100%;
            display: flex;
            align-content: center;
            justify-content: space-between;
            padding: 13px 0 15px 11px;
            &-left{
                color: #000000;
                font-family: "PingFang SC";
                text-align: left;
                &-label{
                    font-size: 16px;
                    font-weight: 600;
                    margin-bottom: 5px;
                    white-space: nowrap;
                    width: 200px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                &-abstract{
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 15px;
                    margin-bottom: 0px;
                    height: 30px;
                    overflow: hidden;
                }
                &-process{
                    width: 168px;
                    height: 7px;
                    position: relative;
                }
            }
            &-right{
                &-proplist{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                    margin-bottom: 9px;
                    &-box{
                        margin: -4px;
                        width: 48px;
                        height: 48px;
                        font-size: 12px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    &-light-view{
                        &-Abs{
                            scale: 0.72;
                            position: absolute;
                            z-index: 2;
                            width: 60px;
                            height: 60px;      
                            // overflow: hidden;  
                        }
                        &-Rel{
                            position: relative;
                            width: 100%;
                            height: 100%;
                        }
                        &-breathe{
                            position: relative;
                            left: 0px;
                            top: 1px;
                            width: 100%;
                            height: 100%;
                            background: url("~@/assets/images/YuliApp/badgeWall/lightEffect_frame.png") no-repeat
                            top left;
                            background-size: 100% 100%;
                            // animation: breatheAni 2s linear infinite;
                        }
                    }
                    &-light{
                        position: absolute;
                        width: @lightSize;
                        height: @lightSize;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        // overflow: hidden;
                        .hideBoxTop{
                            position: absolute;
                            top: -3px;
                            left: 0px;
                            width: @lightSize;
                            height: 11px;
                            overflow: hidden;
                        }
                        .hideBoxBottom{
                            position: absolute;
                            bottom: -3px;
                            right: 0px;
                            width: @lightSize;
                            height: 11px;
                            overflow: hidden;
                        }
                        &-top{
                            position: absolute;
                            top: 0px;
                            left: -33px;
                            visibility: hidden;
                            animation: translateTop @animTime linear infinite; /* 应用旋转光效动画 */
                            animation-fill-mode: both;
                        }
                        &-bottom{
                            position: absolute;
                            bottom: 0px;
                            right: -33px;
                            transform: rotate(180deg);
                            visibility: hidden;
                            animation: translateBottom @animTime linear infinite; /* 应用旋转光效动画 */
                            animation-fill-mode: both;
                        }
                        .hideBoxLeft{
                            position: absolute;
                            bottom: 0px;
                            left: -5px;
                            width: 11px;
                            height: @lightSize;
                            overflow: hidden;
                        }
                        .hideBoxRight{
                            position: absolute;
                            top: 0px;
                            right: -5px;
                            width: 11px;
                            height: @lightSize;
                            overflow: hidden;
                        }
                        &-left{
                            position: absolute;
                            bottom: -18px;
                            left: -12px;
                            transform: rotate(270deg);
                            visibility: hidden;
                            animation: translateLeft @animTime linear infinite; /* 应用旋转光效动画 */
                        }
                        &-right{
                            position: absolute;
                            top: -18px;
                            right: -12px;
                            transform: rotate(90deg);
                            visibility: hidden;
                            animation: translateRight @animTime linear infinite; /* 应用旋转光效动画 */
                        }
                        img{
                            width: 40px;
                            height: 10px;
                        }
                    }
                    // 旋转特效组件 - 上部件
                    @keyframes translateTop {
                        0% {
                            visibility: visible;
                            transform: translateX(0);
                        }
                        45% {
                            transform: translateX(calc(@lightSize + 33px));
                        }
                        46%{
                            visibility: hidden;
                        }
                        62% {
                            visibility: hidden;
                            transform: translateX(0);
                        }
                        63%{
                            visibility: visible;
                            transform: translateX(0);
                        }
                        100%{
                            transform: translateX(calc(@lightSize + 33px));
                        }
                    }
                    // 旋转特效组件 - 下部件
                    @keyframes translateBottom {
                        0% {
                            visibility: visible;
                            transform: rotate(180deg) translateX(0);
                        }
                        45% {
                            transform: rotate(180deg) translateX(calc(@lightSize + 33px));
                        }
                        46%{
                            visibility: hidden;
                        }
                        62% {
                            visibility: hidden;
                            transform: rotate(180deg) translateX(0);
                        }
                        63%{
                            visibility: visible;
                            transform: rotate(180deg) translateX(0);
                        }
                        100%{
                            transform: rotate(180deg) translateX(calc(@lightSize + 33px));
                        }
                    }
                    // 旋转特效组件 - 左部件
                    @keyframes translateLeft {
                        0% {
                            visibility: hidden;    
                        }
                        31% {
                            visibility: hidden;
                        }
                        32%{
                            visibility: visible;
                            transform: rotate(270deg) translateX(0);
                        }
                        82%{
                            visibility: visible;
                            transform: rotate(270deg) translateX(calc(@lightSize + 33px));
                        }
                        83%{
                            visibility: hidden;
                        }
                        100% {
                            visibility: hidden;
                        }
                    }
                    // 旋转特效组件 - 右部件
                    @keyframes translateRight {
                        0% {
                            visibility: hidden;    
                        }
                        31% {
                            visibility: hidden;
                        }
                        32%{
                            visibility: visible;
                            transform: rotate(90deg) translateX(0);
                        }
                        82%{
                            visibility: visible;
                            transform: rotate(90deg) translateX(calc(@lightSize + 33px));
                        }
                        83%{
                            visibility: hidden;
                        }
                    }
                    // 呼吸
                    @keyframes breatheAni {
                        0% {
                            scale: 0.98;
                        }
                        50%{
                            scale: 1.02;
                        }
                        100% {
                            scale: 0.98;
                        }
                    }
                    &-hadClaim{
                        scale: 0.72;
                        position: absolute;
                        width: 48px;
                        height: 48px;
                        background-color: rgba(0, 0, 0, 0.4);
                        z-index: 5;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 23px;
                            height: 23px;
                        }
                    }
                }
                &-button{
                    width: 91px;
                    height: 26px;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgedetail_btn_bg_off.png") no-repeat
                    top left;
                    margin-left: auto;
                    background-size: 100% 100%;
                    font-size: 13px;
                    font-weight: 600;
                    color: #fff;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-end;
                    box-sizing: border-box;
                    padding-right: 7px;
                    img{
                        width: 16px;
                        height: 16px;
                        margin-right: 3px;
                    }
                }
                .btn_active{
                    width: 65px;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgedetail_btn_bg_on.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    position: relative;
                }
                .btn_active::after{
                    content: '';
                    position: absolute;
                    top: -8px;
                    right: 12px;
                    width: 16px;
                    height: 16px;
                    background: url("~@/assets/images/YuliApp/badgeWall/RewardSignal.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                }
            }
        }
        .active{
            background: url("~@/assets/images/YuliApp/badgeWall/reward-item-bg-on.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
        .hadClaim{
            background: url("~@/assets/images/YuliApp/badgeWall/reward-item-bg-off.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
    }
    // yuli情况
    .yuli-view{
        position: relative;
        &-id{
            position: absolute;
            bottom: 36px;
            right: 50%;
            transform: translate(50%, 0);
            color: #F2F2F2;
            font-size: 14.5px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
            text-shadow: 0 1px 2px rgba(64, 41, 17, 0.56), 1px 0 2px rgba(64, 41, 17, 0.56), -1px 0 2px rgba(64, 41, 17, 0.56), 0 -1px 2px rgba(64, 41, 17, 0.56);
            &-gold{
                color: #fffde7;
            }
        }
        img{
            width: 160px;
            height: 160px;
        }
    }
</style>
  